import { render } from "./BoardMemberCard.vue?vue&type=template&id=7f406883"
import script from "./BoardMemberCard.vue?vue&type=script&lang=js"
export * from "./BoardMemberCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__